export default __webpack_public_path__ + "static/media/My project - 2023-05-23T172647.729 (1) (1).709c04ea.png";